import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import '../Admin/Admin.css';
import CollapseCard from '../CollapseCard/CollapseCard';
import Services from './Services';
import ServiceColumns from './ServiceColumns';

class ServicesContainer extends Component {
    constructor(props) {
        super(props);
        this.blankService = {
            serviceId: 0,
            parentServiceId: 0,
            name: '',
            section: '',
            headers: '',
            limit: null,
            serviceAreaId: 0,
            accountNumber: null,
            workAuthorizationNumber: null,
            active: true,
            order: 0,
            deleted: false,
            serviceColumns: [],
            serviceClients: []
        }
        this.blankServiceColumn = {
            serviceColumnId: 0,
            column: '',
            section: '',
            type: '',
            order: 0,
            active: true,
            deleted: false,
            services: []
        }
        this.state = {
            services: [],
            serviceId: 0,
            serviceColumns: [],
            serviceAreas: [],
            editParentService: { ...this.blankService },
            editService: { ...this.blankService },
            editServiceColumn: { ...this.blankServiceColumn },
            newParentService: { ...this.blankService },
            newService: { ...this.blankService },
            newServiceColumn: { ...this.blankServiceColumn },
            isLoaded: false,
        };
    }

    componentDidMount() {
        this.props.log('ServicesContainer.js/componentDidMount');
        this.getServices();
    }

    getServices = () => {
        this.props.log('ServicesContainer.js/getServices');
        fetch('/api/services/', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState({
                        services: results.services,
                        serviceColumns: results.serviceColumns,
                        serviceAreas: results.serviceAreas,
                        isLoaded: true
                    });
                } else {
                    this.props.addToast('Unable to load services.', 5, 'danger');
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    onEditService = (serviceId, parent = false) => {
        this.props.log('ServicesContainer.js/onEditService (serviceId,parent)', serviceId, parent);
        let service = [...this.state.services].filter(item => item.serviceId === serviceId)[0];
        let serviceColumns = [], serviceClients = [];
        if (service == null) {
            service = [...this.state.services].filter(service => service.services != null).map(service => service.services).flat().filter(item => item.serviceId === serviceId)[0];
            serviceColumns = service.fields != null ? service.fields : [];
            serviceClients = service.clients != null ? service.clients.map(client => { return ({ clientId: client }) }) : [];
        } else {
            serviceColumns = service.serviceColumns != null ? service.serviceColumns : [];
            serviceClients = service.serviceClients != null ? service.serviceClients : [];
        }
        const obj = {
            serviceId: service.serviceId,
            parentServiceId: parent ? service.parentServiceId : this.state.editParentService.serviceId,
            name: service.name,
            section: service.section,
            headers: service.headers,
            limit: service.limit,
            serviceAreaId: service.serviceAreaId,
            accountNumber: service.accountNumber,
            workAuthorizationNumber: service.workAuthorizationNumber,
            active: service.active,
            order: service.order,
            deleted: service.deleted,
            serviceColumns: serviceColumns != null ? serviceColumns : [],
            serviceClients: serviceClients != null ? serviceClients : []
        }
        this.setState(() => {
            return (parent) ? { editParentService: obj } : { editService: obj };
        });
    }

    onDeleteService = (serviceId) => {
        this.props.log('ServicesContainer.js/onDeleteService (serviceId)', serviceId);
        fetch('/api/services/' + serviceId, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.props.addToast('Service deleted successfully.', 5, 'success')
                    this.getServices();
                } else {
                    this.props.addToast('Unable to delete service.', 5, 'danger')
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    onChangeService = (e, type, parent = false) => {
        this.props.log('ServicesContainer.js/onChangeService (e, type, parent)', e, type, parent);
        e.persist();
        let thisService = (type === 'edit') ?
            (parent ? this.state.editParentService : this.state.editService) :
            (parent ? this.state.newParentService : this.state.newService)
        switch (e.target.name) {
            case "active":
                thisService[e.target.name] = !thisService[e.target.name];
                break;
            case "serviceColumns":
                const serviceColumnId = parseInt(String(e.target.id).split('_')[1]);
                const index = thisService.serviceColumns.findIndex(item => item.serviceColumnId === serviceColumnId);
                if (index > -1) thisService.serviceColumns.splice(index, 1);
                if (e.target.checked) thisService.serviceColumns.push({ serviceColumnId: serviceColumnId, order: 10000 });
                break;
            case "serviceClients":
                const clientId = parseInt(String(e.target.id).split('_')[1]);
                const index2 = thisService.serviceClients.findIndex(item => item.clientId === clientId);
                if (index2 > -1) thisService.serviceClients.splice(index2, 1);
                if (e.target.checked) thisService.serviceClients.push({ clientId: clientId });
                break;
            default:
                thisService[e.target.name] = e.target.value;
        }
        this.setState((prevState) => {
            if (parent) {
                return (type === 'edit') ? { editParentService: thisService } : { newParentService: thisService };
            } else {
                return (type === 'edit') ? { editService: thisService } : { newService: thisService };
            }
        });
    }

    handleCancelService = (parent = false) => {
        this.props.log('ServicesContainer.js/handleCancelService (parent)', parent);
        this.setState(() => {
            return (parent) ? { editParentService: { ...this.blankService }, editService: { ...this.blankService } } : { editService: { ...this.blankService } };
        });
    }

    handleAddService = (parent) => {
        this.props.log('ServicesContainer.js/handleAddService (parent)', parent);
        let newOrder = parent ?
            Math.max(...this.state.services.map(i => i['order']), 0) + 10 :
            Math.max(...this.state.services.filter(service => service.serviceId === this.state.editParentService.serviceId)[0].services.map(i => i['order']), 0) + 10;
        fetch('/api/services/', {
            method: 'POST',
            body: JSON.stringify({
                parentServiceId: parent ? this.state.newParentService.parentServiceId : this.state.editParentService.serviceId,
                name: parent ? this.state.newParentService.name : this.state.newService.name,
                section: parent ? this.state.newParentService.section : this.state.newService.section,
                headers: parent ? this.state.newParentService.headers : this.state.newService.headers,
                limit: parent ? this.state.newParentService.limit : this.state.newService.limit,
                serviceAreaId: parent ? this.state.newParentService.serviceAreaId : this.state.newService.serviceAreaId,
                accountNumber: parent ? this.state.newParentService.accountNumber : this.state.newService.accountNumber,
                workAuthorizationNumber: parent ? this.state.newParentService.workAuthorizationNumber : this.state.newService.workAuthorizationNumber,
                active: parent ? this.state.newParentService.active : this.state.newService.active,
                order: newOrder,
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        })
            .then(results => results.json())
            .then(results => {
                if (parseInt(results.data) > 0) {
                    this.setState(() => {
                        return (parent) ? { newParentService: { ...this.blankService } } : { newService: { ...this.blankService } }
                    }, () => this.getServices());
                    this.props.addToast('Service added successfully.', 5, 'success')
                } else {
                    this.props.addToast('Unable to add service.', 5, 'danger')
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    handleEditService = (parent) => {
        this.props.log('ServicesContainer.js/handleEditService (parent)', parent);
        fetch('/api/services/' + (parent ? this.state.editParentService.serviceId : this.state.editService.serviceId), {
            method: 'PUT',
            body: JSON.stringify({
                parentServiceId: parent ? this.state.editParentService.parentServiceId : this.state.editService.parentServiceId,
                name: parent ? this.state.editParentService.name : this.state.editService.name,
                section: parent ? this.state.editParentService.section : this.state.editService.section,
                headers: parent ? this.state.editParentService.headers : this.state.editService.headers,
                limit: parent ? this.state.editParentService.limit : this.state.editService.limit,
                serviceAreaId: parent ? this.state.editParentService.serviceAreaId : this.state.editService.serviceAreaId,
                accountNumber: parent ? this.state.editParentService.accountNumber : this.state.editService.accountNumber,
                workAuthorizationNumber: parent ? this.state.editParentService.workAuthorizationNumber : this.state.editService.workAuthorizationNumber,
                active: parent ? this.state.editParentService.active : this.state.editService.active,
                serviceColumns: parent ? this.state.editParentService.serviceColumns : this.state.editService.serviceColumns,
                serviceClients: parent ? this.state.editParentService.serviceClients : this.state.editService.serviceClients
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState(() => {
                        return (parent) ? { editParentService: { ...this.blankService }, editServiceColumn: { ...this.blankServiceColumn } } :
                            { editService: { ...this.blankService }, editServiceColumn: { ...this.blankServiceColumn } }
                    }, () => this.getServices());
                    this.props.addToast('Service updated successfully.', 5, 'success')
                } else {
                    this.props.addToast('Unable to update service.', 5, 'danger')
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    onChangeServiceColumn = (e, type) => {
        this.props.log('ServicesContainer.js/onChangeServiceColumn (e,type)', e, type);
        e.persist();
        let thisServiceColumn = (type === 'edit') ? this.state.editServiceColumn : this.state.newServiceColumn;
        switch (e.target.name) {
            case "active":
                thisServiceColumn[e.target.name] = !thisServiceColumn[e.target.name];
                break;
            case "services":
                const serviceId = parseInt(String(e.target.id).split('_')[1]);
                const index = thisServiceColumn.services.findIndex(item => item.serviceId === serviceId);
                if (index > -1) thisServiceColumn.services.splice(index, 1);
                if (e.target.checked) thisServiceColumn.services.push({ serviceId: serviceId, order: 10000 });
                break;
            default:
                thisServiceColumn[e.target.name] = e.target.value;
        }
        this.setState((prevState) => {
            return (type === 'edit') ? { editServiceColumn: thisServiceColumn } : { newServiceColumn: thisServiceColumn };
        });
    }

    onEditServiceColumn = (serviceColumnId) => {
        this.props.log('ServicesContainer.js/onEditServiceColumn (serviceColumnId)', serviceColumnId);
        const serviceColumnTask = [...this.state.serviceColumns].filter(item => item.serviceColumnId === serviceColumnId)[0];
        this.setState(() => {
            return {
                editServiceColumn: {
                    serviceColumnId: serviceColumnId,
                    column: serviceColumnTask.column,
                    section: serviceColumnTask.section,
                    type: serviceColumnTask.type != null ? serviceColumnTask.type : '',
                    order: serviceColumnTask.order,
                    active: serviceColumnTask.active,
                    services: [...this.state.services].filter(service => service.services != null).map(service => service.services).flat()
                        .filter(service => service.fields != null && service.fields.findIndex(i => i.serviceColumnId === serviceColumnId) > -1)
                        .map(service => { return { serviceId: service.serviceId, order: service.order } })
                }
            }
        })
    }

    onDeleteServiceColumn = (serviceColumnId) => {
        this.props.log('ServicesContainer.js/onDeleteServiceColumn (serviceColumnId)', serviceColumnId);
        fetch('/api/service-columns/' + serviceColumnId, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.props.addToast('Service column deleted successfully.', 5, 'success')
                    this.getServices();
                } else {
                    this.props.addToast('Unable to delete service column.', 5, 'danger')
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    handleCancelServiceColumn = () => {
        this.props.log('ServicesContainer.js/handleCancelServiceColumn');
        this.setState({
            editServiceColumn: { ...this.blankServiceColumn },
        })
    }

    handleEditServiceColumn = () => {
        this.props.log('ServicesContainer.js/handleEditServiceColumn');
        fetch('/api/service-columns/' + this.state.editServiceColumn.serviceColumnId, {
            method: 'PUT',
            body: JSON.stringify({
                column: this.state.editServiceColumn.column,
                section: this.state.editServiceColumn.section,
                type: this.state.editServiceColumn.type,
                order: this.state.editServiceColumn.order,
                active: this.state.editServiceColumn.active,
                services: this.state.editServiceColumn.services
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState({
                        editService: { ...this.blankService },
                        editServiceColumn: { ...this.blankServiceColumn }
                    }, () => this.getServices());
                    this.props.addToast('Service column updated successfully.', 5, 'success')
                } else {
                    this.props.addToast('Unable to update service column.', 5, 'danger')
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    handleAddServiceColumn = (e) => {
        this.props.log('ServicesContainer.js/handleAddServiceColumn');
        let newOrder = Math.max(...this.state.serviceColumns.map(i => i['order']), 0) + 10;
        fetch('/api/service-columns/', {
            method: 'POST',
            body: JSON.stringify({
                column: this.state.newServiceColumn.column,
                section: this.state.newServiceColumn.section,
                type: this.state.newServiceColumn.type,
                order: newOrder,
                active: this.state.newServiceColumn.active
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        })
            .then(results => results.json())
            .then(results => {
                if (parseInt(results.data) > 0) {
                    this.setState({
                        newServiceColumn: { ...this.blankServiceColumn }
                    }, () => this.getServices());
                    this.props.addToast('Service column added successfully.', 5, 'success')
                } else {
                    this.props.addToast('Unable to add service column.', 5, 'danger')
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    setDragTarget = (serviceId) => {
        this.props.log('ServicesContainer.js/setDragTarget (serviceId)', serviceId);
        this.setState({
            serviceId: serviceId
        })
    }

    reorder = (parent = false) => {
        this.props.log('ServicesContainer.js/reorder(parent)', parent);
        let dbServices = [];
        let data = [...this.state.services];
        if (parent) {
            data = data.map((service, serviceIndex) => {
                if (dbServices.findIndex(item => item.serviceId === service.serviceId) === -1) dbServices.push({ serviceId: service.serviceId, order: (serviceIndex + 1) * 10 })
                return { ...service, order: (serviceIndex + 1) * 10 }
            })
        } else {
            const dataIndex = data.findIndex(service => service.serviceId === this.state.editParentService.serviceId);
            let dataServices = data[dataIndex].services;
            dataServices = dataServices.map((service, serviceIndex) => {
                if (dbServices.findIndex(item => item.serviceId === service.serviceId) === -1) dbServices.push({ serviceId: service.serviceId, order: (serviceIndex + 1) * 10 })
                return { ...service, order: (serviceIndex + 1) * 10 }
            })
            data[dataIndex].services = dataServices;
        }
        this.setState({ services: data }, () => {
            fetch('/api/services-order/', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + this.props.clientToken
                },
                body: JSON.stringify(
                    { services: dbServices, serviceColumns: [] }
                )
            }, () => this.getServices())
        });
    }

    reorderServiceColumns = () => {
        this.props.log('ServicesContainer.js/reorderServiceColumns');
        let dbServiceColumns = [];
        let data = [...this.state.serviceColumns];
        data = data.map((serviceColumn, serviceColumnIndex) => {
            if (dbServiceColumns.findIndex(item => item.serviceColumnId === serviceColumn.serviceColumnId) === -1) dbServiceColumns.push({ serviceColumnId: serviceColumn.serviceColumnId, order: (serviceColumnIndex + 1) * 10 })
            return { ...serviceColumn, order: (serviceColumnIndex + 1) * 10 }
        })
        this.setState({ serviceColumns: data }, () => {
            fetch('/api/services-order/', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + this.props.clientToken
                },
                body: JSON.stringify(
                    { services: [], serviceColumns: dbServiceColumns }
                )
            }, () => this.getServices())
        });
    }

    render() {
        this.props.info('ServicesContainer.js/render');
        const dragPropsParent = {
            onDragEnd: (fromIndex, toIndex) => {
                const data = [...this.state.services];
                const item = data.splice(fromIndex, 1)[0];
                data.splice(toIndex, 0, item);
                this.setState({ services: data }, () => this.reorder(true));
            },
            nodeSelector: 'div.serviceRowParent',
            handleSelector: 'span.dragIconParent'
        };
        const dragProps = {
            onDragEnd: (fromIndex, toIndex) => {
                const data = [...this.state.services]
                const dataIndex = data.findIndex(service => service.serviceId === this.state.editParentService.serviceId);
                const dataServices = data[dataIndex].services;
                const item = dataServices.splice(fromIndex, 1)[0];
                dataServices.splice(toIndex, 0, item);
                data[dataIndex].services = dataServices;
                this.setState({ services: data }, () => this.reorder());
            },
            nodeSelector: 'div.serviceRow',
            handleSelector: 'span.dragIcon'
        };
        const dragPropsServiceColumn = {
            onDragEnd: (fromIndex, toIndex) => {
                const data = [...this.state.serviceColumns];
                const item = data.splice(fromIndex, 1)[0];
                data.splice(toIndex, 0, item);
                this.setState({ serviceColumns: data },
                    () => this.reorderServiceColumns()
                );
            },
            nodeSelector: 'div.serviceColumnRow',
            handleSelector: 'span.dragIconServiceColumn'
        };

        return (
            (this.state.isLoaded) ?
                <>
                    <CollapseCard title="Service Management" open={true}>
                        <Services
                            {...this.props}
                            services={this.state.services}
                            serviceColumns={this.state.serviceColumns}
                            serviceAreas={this.state.serviceAreas}
                            newParentService={this.state.newParentService}
                            newService={this.state.newService}
                            editParentService={this.state.editParentService}
                            editService={this.state.editService}
                            dragProps={dragProps}
                            dragPropsParent={dragPropsParent}
                            onChange={this.onChangeService}
                            onEdit={this.onEditService}
                            onDelete={this.onDeleteService}
                            handleAdd={this.handleAddService}
                            handleEdit={this.handleEditService}
                            handleCancel={this.handleCancelService}
                            setDragTarget={this.setDragTarget}
                            log={this.props.log}
                            info={this.props.info}
                        />
                    </CollapseCard>
                    <CollapseCard title="Services Pricing Types" open={true}>
                        <ServiceColumns
                            {...this.props}
                            services={this.state.services}
                            serviceColumns={this.state.serviceColumns}
                            newServiceColumn={this.state.newServiceColumn}
                            editServiceColumn={this.state.editServiceColumn}
                            dragPropsServiceColumn={dragPropsServiceColumn}
                            onChange={this.onChangeServiceColumn}
                            onEdit={this.onEditServiceColumn}
                            onDelete={this.onDeleteServiceColumn}
                            handleAdd={this.handleAddServiceColumn}
                            handleEdit={this.handleEditServiceColumn}
                            handleCancel={this.handleCancelServiceColumn}
                            // setDragTarget={this.setDragTarget}
                            log={this.props.log}
                            info={this.props.info}
                        />
                    </CollapseCard>
                </>
                :
                <h3>Loading...</h3>
        );

    }
}

export default ServicesContainer;
